import React from 'react'
import { Select } from 'antd'

const { Option } = Select

export const CustomMultiSelect = ({ options, placeholder, ...props }) => {
  return (
    <Select
      mode="multiple"
      placeholder={placeholder}
      style={{
        width: '100%',
        fontSize: '12px'
      }}
      {...props}
    >
      {options.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  )
}